import { SAMPLES_ALLOWED_ROLES } from '@/config/samples';
import SamplesPage from '@/pages/Samples/SamplesPage';
import { useAppStore } from '@/stores/app';
import { useUnauthorizedReferrerStore } from '@/stores/unauthorizedReferrerStore';
import { hasOrgRole } from '@helpers/roles';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/samples/')({
  beforeLoad: ({ context, location }) => {
    if (context.authentication.status === 'PENDING') return;

    // No user means no authorization decision is possible, so this belongs with /login rather
    // than /unauthorized — and it keeps the role gate below from being skipped silently (it was
    // previously a sibling condition on the role check, not a fail-closed guard ahead of it).
    if (context.authentication.status === 'UNAUTHENTICATED' || !context.authentication.user) {
      throw redirect({ to: '/login' });
    }

    const store = useAppStore.getState();
    const selectedOrganization = store.selectedOrganization || store.selectedOrgStub;

    if (!selectedOrganization) {
      useUnauthorizedReferrerStore.getState().setReferrerPath(location.pathname);
      throw redirect({ to: '/unauthorized' });
    }

    const rolesRaw = context.authentication.user.assumed_roles;
    if (!SAMPLES_ALLOWED_ROLES.some(role => hasOrgRole(rolesRaw, selectedOrganization.id, role))) {
      useUnauthorizedReferrerStore.getState().setReferrerPath(location.pathname);
      throw redirect({ to: '/unauthorized' });
    }
  },
  component: SamplesPage,
});
